import AxiosClient from "../../../services/axios.services";

class ObjectiveValuePillarServices {
  getObjectiveValuePillar = (params) =>
    AxiosClient.get("/api/app/evaluacion_objetivos_valores_pilar/",
      {
        headers: { "Content-Type": "application/json" },
        params: params,
      }
    );
  getObjectiveValuePillarById = (id) =>
    AxiosClient.get(`/api/app/evaluacion_objetivos_valores_pilar/${id}/`,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
  saveObjectiveValuePillar = (data) =>
    AxiosClient.post("/api/app/evaluacion_objetivos_valores_pilar/",
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
  editObjectiveValuePillar = (id, data) =>
    AxiosClient.put(`/api/app/evaluacion_objetivos_valores_pilar/${id}/`,
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
  deleteObjectiveValuePillar = (id) =>
    AxiosClient.delete(`/api/app/evaluacion_objetivos_valores_pilar/${id}/`,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
}

export default new ObjectiveValuePillarServices();
